import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { Delete } from '@material-ui/icons';
import { ActionItem } from 'common/components';
import bookingMessages from 'modules/booking/messages';

interface IBookingActionItemDelete {
  onClick: () => void;
}

const BookingActionItemDelete: FC<IBookingActionItemDelete> = ({ onClick }) => {
  const intl = useIntl();

  return (
    <ActionItem key="deleteEventAction" onClick={onClick} icon={<Delete />}>
      {intl.formatMessage(bookingMessages.deleteEventBtn)}
    </ActionItem>
  );
};

export default BookingActionItemDelete;
